import React, { useEffect } from "react";

export default function WebHomePage({ onLogin }) {
  useEffect(() => {
    document.body.className = "theme-ocean";
  }, []);

  return (
    <div className="home-landing">
      <div className="glass home-landing-shell">
        <div className="home-landing-hero">
          <span className="home-landing-badge">FamilySync</span>
          <h1>Family chores, rewards, and routines in one simple place.</h1>
          <p>
            FamilySync helps parents assign tasks, kids complete them, and everyone stay in sync
            with approvals, clarifications, and calendar events.
          </p>
          <div className="home-landing-actions">
            <button className="btn-nav success-btn" type="button" onClick={onLogin}>
              Login
            </button>
          </div>
        </div>

        <div className="home-landing-panel">
          <h3>What you can do</h3>
          <ul>
            <li>Assign chores and track completion</li>
            <li>Review approvals and clarifications in separate flows</li>
            <li>Manage kid access and family settings</li>
            <li>Keep everyone aligned with calendar + reminders</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
